import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="footer-container">
        {/* Column 1: Brand */}
        <div className="footer-col">
          <Link to="/" className="footer-brand">
            <Icon icon="mdi:food-turkey" />
            <span>FoodExpress</span>
          </Link>
          <p className="footer-tagline">
            Delicious food delivered to your door in 30 minutes. Fresh, hot, and always on time.
          </p>
          <div className="footer-socials">
            <button type="button" className="social-icon" aria-label="Instagram">
              <Icon icon="mdi:instagram" width="20" />
            </button>
            <button type="button" className="social-icon" aria-label="Facebook">
              <Icon icon="mdi:facebook" width="20" />
            </button>
            <button type="button" className="social-icon" aria-label="Twitter">
              <Icon icon="mdi:twitter" width="20" />
            </button>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/menu" className="footer-link">Menu</Link>
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>
        </div>

        {/* Column 3: Support */}
        <div className="footer-col">
          <h3>Support</h3>
          <div className="footer-links">
            <Link to="/faq" className="footer-link">FAQ</Link>
            <Link to="/orders" className="footer-link">Track Order</Link>
            <Link to="/policy" className="footer-link">Return Policy</Link>
            <Link to="/help" className="footer-link">Help Center</Link>
          </div>
        </div>

        {/* Column 4: Contact & Newsletter */}
        <div className="footer-col">
          <h3>Contact Us</h3>
          <div className="footer-links" style={{marginBottom: '16px'}}>
            <span className="footer-link" style={{display:'flex', alignItems:'center', gap:'8px'}}>
              <Icon icon="mdi:map-marker-outline" width="18" /> Patna, Bihar, India
            </span>
            <span className="footer-link" style={{display:'flex', alignItems:'center', gap:'8px'}}>
              <Icon icon="mdi:phone-outline" width="18" /> +91 98765 43210
            </span>
            <span className="footer-link" style={{display:'flex', alignItems:'center', gap:'8px'}}>
              <Icon icon="mdi:email-outline" width="18" /> support@foodexpress.com
            </span>
          </div>
          <h3>Newsletter</h3>
          <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
            <input type="email" placeholder="Your email address" className="newsletter-input" />
            <button type="submit" className="newsletter-btn">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} FoodExpress. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
